import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import CircleNotificationsOutlinedIcon from "@mui/icons-material/CircleNotificationsOutlined";
import { Box, Popover } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import { ButtonVariant } from "Constant/button";
import { routes } from "Constant/routes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { popoverMenuPaperSx } from "components/atoms/PopoverMenu";
import StandartButton from "components/atoms/StandartButton";

import {
    getNotificationsRedux,
    getNotificationsSummary,
} from "../../../redux/slices/notifications/notifications.asyncActions";
import "../notifications.css";
import * as Styled from "./NotificationBell.styled";

const Notification = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const notificationButtonRef = useRef(null);
    const language = useSelector((state) => state.languagesState.languages);
    const [isOpen, setIsOpen] = useState(false);
    const isMobileSidebar = useMediaQuery("(max-width: 991px)");

    useEffect(() => {
        dispatch(getNotificationsRedux({ page: 1, per_page: 5 }));
        dispatch(getNotificationsSummary());
    }, [dispatch]);

    const { summary, notifications } = useSelector(
        (state) => state.notificationsState,
    );

    const unreadCount = useMemo(() => summary?.unread_count || 0, [summary]);
    const data = useMemo(
        () => notifications?.notifications || [],
        [notifications],
    );

    const handleIconClick = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    const readNotification = useCallback(
        (item) => {
            navigate(`${routes.notification_view}?notification_id=${item?.id}`);
        },
        [navigate],
    );

    return (
        <Box
            className="notification-container"
            sx={{ position: "relative", width: "100%", mb: "10px" }}
        >
            <StandartButton
                variant={ButtonVariant.NOTIFICATION}
                setRef={notificationButtonRef}
                id="notificationDropdownButton"
                aria-controls="notificationDropdown"
                aria-expanded={isOpen}
                fullWidth
                onClick={handleIconClick}
                startIcon={<CircleNotificationsOutlinedIcon />}
                sx={{ justifyContent: "flex-start", width: "100%" }}
            >
                {language?.buttons?.notifications ?? "Notifications"}
                {unreadCount > 0 && (
                    <span className="unread-length">{unreadCount}</span>
                )}
            </StandartButton>
            <Popover
                id="notificationDropdown"
                open={isOpen}
                anchorEl={notificationButtonRef.current}
                onClose={() => setIsOpen(false)}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: isMobileSidebar ? "left" : "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: isMobileSidebar ? "right" : "left",
                }}
                slotProps={{
                    paper: {
                        sx: {
                            ...popoverMenuPaperSx,
                            mt: 0,
                            minWidth: 300,
                            ...(isMobileSidebar
                                ? { mr: "8px" }
                                : { ml: "8px" }),
                        },
                    },
                }}
                disableRestoreFocus
                disableScrollLock
            >
                <Box
                    className="notification-content custom-scrollbar"
                    sx={{
                        maxHeight: "20rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "6px",
                    }}
                >
                    {!!data?.length &&
                        data?.map(
                            (item, index) =>
                                index < 5 && (
                                    <Styled.ItemContainer
                                        key={item?.id}
                                        onClick={() => {
                                            readNotification(item);
                                            setIsOpen(false);
                                        }}
                                    >
                                        <Box>
                                            <Styled.Read
                                                $isRead={!!item?.read_at}
                                            />
                                        </Box>
                                        <Box>
                                            <Styled.Title>
                                                {item?.title}
                                            </Styled.Title>
                                            <Styled.Date>
                                                {item?.created_at}
                                            </Styled.Date>
                                        </Box>
                                    </Styled.ItemContainer>
                                ),
                        )}

                    {!data?.length && (
                        <Styled.EmptyState>
                            {language?.notification_page?.there_is_no_new ??
                                "There is no new notification."}
                        </Styled.EmptyState>
                    )}
                </Box>
                {!!data?.length && (
                    <Box
                        className="notificationsLink"
                        sx={{ borderTop: "1px solid #f2f2f4" }}
                    >
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            fullWidth
                            onClick={() => {
                                navigate(routes.notification_view);
                                setIsOpen(false);
                            }}
                        >
                            {"View All Notifications"}
                        </StandartButton>
                    </Box>
                )}
            </Popover>
        </Box>
    );
};

export default Notification;
